var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouseMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    fill: "currentColor",
    style: {
      enableBackground: "new 0 0 91 91"
    },
    viewBox: "0 0 91 91",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "40.4,38.6 40.4,49.8 52.5,49.8 52.5,38.6 46.4,34.7  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4,20c-12.6,0-22.9,10.3-22.9,22.9c0,10.4,7.2,19.6,17.2,22.2L45.3,77c0.2,0.5,0.6,0.8,1.2,0.8c0,0,0,0,0,0   c0.5,0,1-0.3,1.2-0.8l4.3-11.8c10.1-2.5,17.4-11.7,17.4-22.2C69.3,30.3,59.1,20,46.4,20z M60,43.5l-4.1-2.7v12.4H37V40.8l-4.1,2.7   L31,40.7l14.5-9.4c0.6-0.4,1.3-0.4,1.8,0l14.5,9.4L60,43.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseMarker);
export default __webpack_public_path__ + "static/media/house-marker.0e10092633b42d4df898a43f3d34196b.svg";
export { ForwardRef as ReactComponent };